import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { usePause } from '@/api/pauses';
import { useHasQueueMetrics } from '@/api/use-branch-features';
import { defaultPauseReasons } from '@/config/default-pause-reasons';
import { useExtension } from '@/hooks/use-extension';
import { subscribe } from '@/lib/desktop-sse';
import { notifyDialogAtom } from '@/store/atoms';

export const usePauseOnMissedCallSSE = () => {
  const extension = useExtension();
  const hasQueueMetrics = useHasQueueMetrics();
  const { mutate: pause } = usePause();
  const setNotifyDialog = useSetAtom(notifyDialogAtom);

  const onPauseOnMissedCall = useCallback(() => {
    if (hasQueueMetrics !== true || !extension) return;
    pause(
      {
        extension: extension.number,
        reasonCode: defaultPauseReasons.NOT_ANSWERED_PAUSE,
      },
      {
        onSuccess: () =>
          setNotifyDialog({ open: true, message: 'missedCallPauseMessage' }),
      }
    );
  }, [hasQueueMetrics, extension, pause, setNotifyDialog]);

  useEffect(() => {
    return subscribe(
      'pause-on-missed-call',
      onPauseOnMissedCall as unknown as (ev: MessageEvent) => void
    );
  }, [onPauseOnMissedCall]);
};
